<script setup lang="ts">
import {ICellRendererParams} from "ag-grid-community";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import Translator from "@/utils/common/Translator.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";

const props = defineProps<{ params: ICellRendererParams }>();

const fieldValue = props.params.value
const highlightedHtml = AGGridUtils.getFindHighlightedHtml(props.params.api, props.params.node, props.params.column, fieldValue ?? '')
const whatsLink = fieldValue ? "https://wa.me/" + fieldValue : "";
const callLink = fieldValue ? "tel:" + fieldValue : "";
const mWindow = (window as any);
</script>

<template>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
    <span v-if="highlightedHtml" v-html="highlightedHtml" class="tw-overflow-hidden"/>
    <span v-else v-text="fieldValue" class="tw-overflow-hidden"/>
    <div class="tw-flex tw-items-center tw-gap-1">
      <q-avatar square @click.stop="mWindow.open(callLink,'_blank')" rel="noopener noreferrer"
                :title="Translator.translateId('phoneCall')"
                class="nama-avatar-hover tw-cursor-pointer">
        <NamaIcon default-icon="nm-phone-call" class="tw-size-5 active-primary"/>
      </q-avatar>
      <q-avatar square @click.stop="mWindow.open(whatsLink,'_blank')" rel="noopener noreferrer"
                :title="Translator.translateId('whatsappMessage')"
                class="nama-avatar-hover tw-cursor-pointer">
        <NamaIcon default-icon="nm-whats-app" class="tw-size-5 active-primary"/>
      </q-avatar>
    </div>
  </div>
</template>
